import PropTypes from 'prop-types';
import React from 'react';
import styles from './SearchBar-style.scss';

const SearchBarTerm = ({ href, term, handleRowClick }) => (
    <div className={styles.item}>
        <span
            className={styles.link}
            onClick={() => { handleRowClick(term, href); }}
        >
            {term}
        </span>
    </div>
);

SearchBarTerm.propTypes = {
    term: PropTypes.string,
    href: PropTypes.string,
    handleRowClick: PropTypes.func
};

export default SearchBarTerm;



// WEBPACK FOOTER //
// ./src/components/SearchBar/SearchBarTerm.jsx